import { observer } from "mobx-react-lite";

import { EditDialogModal } from "@/features/edit-dialog";

import { useStore } from "../../model/RootStoreContext";

const EditDialogModalProvider = observer(() => {
  const { editDialogStore } = useStore();

  return (
    <EditDialogModal
      isOpen={editDialogStore.isOpen}
      onClose={() => editDialogStore.close()}
      {...editDialogStore.options}
    />
  );
});

export default EditDialogModalProvider;
